import { Link } from "react-router-dom";
import type { Movie } from "@/types/movie";

interface TopicCollectionsProps {
  popular: Movie[];
  hotDramas: Movie[];
}

function RankingList({ title, icon, items, to }: { title: string; icon: string; items: Movie[]; to: string }) {
  return (
    <div className="bg-background-50 border border-background-200 rounded-lg p-5 md:p-6">
      <div className="flex items-center justify-between mb-5">
        <div className="flex items-center gap-2.5">
          <span className="w-9 h-9 rounded-md bg-primary-50 flex items-center justify-center">
            <i className={`${icon} text-lg text-primary-500`}></i>
          </span>
          <h3 className="font-heading font-black text-foreground-950 text-base md:text-lg">{title}</h3>
        </div>
        <Link to={to} className="text-xs text-foreground-500 hover:text-primary-500 whitespace-nowrap">
          全部
        </Link>
      </div>
      <ol className="space-y-3">
        {items.map((movie, i) => (
          <li key={movie.id}>
            <Link to={`/detail/${movie.id}`} className="group flex items-center gap-3">
              <span
                className={`w-6 h-6 shrink-0 rounded-md flex items-center justify-center text-xs font-black ${
                  i < 3 ? "bg-accent-500 text-background-50" : "bg-background-200 text-foreground-600"
                }`}
              >
                {i + 1}
              </span>
              <span className="w-11 h-14 shrink-0 rounded-md overflow-hidden bg-background-200">
                <img
                  src={movie.cover}
                  alt={`${movie.title} 海报`}
                  title={`${movie.title} - 缘之空`}
                  className="w-full h-full object-cover object-top"
                />
              </span>
              <span className="min-w-0 flex-1">
                <span className="block text-sm font-medium text-foreground-950 truncate group-hover:text-primary-500 transition-colors">
                  {movie.title}
                </span>
                <span className="block text-xs text-foreground-500 truncate">
                  {movie.genres.join(" · ")} · {movie.year}
                </span>
              </span>
              <span className="shrink-0 text-sm font-bold text-accent-600">{movie.rating.toFixed(1)}</span>
            </Link>
          </li>
        ))}
      </ol>
    </div>
  );
}

export default function TopicCollections({ popular, hotDramas }: TopicCollectionsProps) {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-6">
      <RankingList title="最受欢迎电影" icon="ri-fire-line" items={popular} to="/category/movie" />
      <RankingList title="热播剧集榜" icon="ri-tv-2-line" items={hotDramas} to="/category/drama" />
    </div>
  );
}